import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';

export default function isDonationField(
  field: ConstituentSearchFilterField | string,
) {
  const donationFields: string[] = [
    ConstituentSearchFilterField.DONATION_TYPES,
    ConstituentSearchFilterField.CAMPAIGN_IDS,
    ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_AMOUNT,
    ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_AMOUNT,
    ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_AMOUNT,
    ConstituentSearchFilterField.DONATION_AMOUNT,
    ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_TIME,
    ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_TIME,
    ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_TIME,
    ConstituentSearchFilterField.DONATION_MINUTES,
    ConstituentSearchFilterField.DONATION_PLAN_CADENCE,
    ConstituentSearchFilterField.IN_HONOR,
    ConstituentSearchFilterField.DONATION_DATE,
    ConstituentSearchFilterField.DONATION_MADE,
    ConstituentSearchFilterField.DONATION_LABEL_IDS,
  ];

  return donationFields.includes(field);
}
